import PropTypes from "prop-types";

const EmptyListMessage = ({message, className}) => {
    return (
        <section className={`empty_data_warning ${className}`}>
            <h3>{message}</h3>
        </section>
    );
}
EmptyListMessage.defaultProps = {
    className: ''
}
EmptyListMessage.propTypes = {
    message: PropTypes.string.isRequired,
    className: PropTypes.string,
}
export default EmptyListMessage;
